"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFormValuesToScheduleRequest = exports.parseScheduleResponseToFormValues = exports.getScheduleStatusText = exports.getScheduleType = exports.SchedulePlatformType = exports.ScheduleType = exports.LocationType = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var types_1 = require("@/types");
var _1 = require(".");
exports.LocationType = {
    OFFLINE: 'offline',
    ONLINE: 'online',
};
exports.ScheduleType = {
    PLATFORM: 'PLATFORM',
    ALL: 'ALL',
};
exports.SchedulePlatformType = {
    ALL: 'ALL',
    ANDROID: 'ANDROID',
    IOS: 'IOS',
    WEB: 'WEB',
    SPRING: 'SPRING',
    NODE: 'NODE',
    DESIGN: 'DESIGN',
};
var getScheduleType = function (type) {
    switch (type) {
        case exports.SchedulePlatformType.ALL:
            return '전체';
        case exports.SchedulePlatformType.ANDROID:
            return 'Android';
        case exports.SchedulePlatformType.IOS:
            return 'iOS';
        case exports.SchedulePlatformType.WEB:
            return 'Web';
        case exports.SchedulePlatformType.SPRING:
            return 'Spring';
        case exports.SchedulePlatformType.NODE:
            return 'Node';
        case exports.SchedulePlatformType.DESIGN:
            return 'Design';
        default:
            return '';
    }
};
exports.getScheduleType = getScheduleType;
var getScheduleStatusText = function (status) {
    switch (status) {
        case types_1.ScheduleStatus.ADMIN_ONLY:
            return '-';
        case types_1.ScheduleStatus.PUBLIC:
            return '배포 완료';
        default:
            return '';
    }
};
exports.getScheduleStatusText = getScheduleStatusText;
var parseScheduleResponseToFormValues = function (response) {
    var name = response.name, generationNumber = response.generationNumber, responseScheduleType = response.scheduleType, startedAt = response.startedAt, eventList = response.eventList, _a = response.location, roadAddress = _a.roadAddress, detailAddress = _a.detailAddress, latitude = _a.latitude, longitude = _a.longitude, notice = response.notice;
    var date = (0, dayjs_1.default)(startedAt, 'YYYY-MM-DD').startOf('day');
    var sessions = eventList.map(function (event) { return ({
        name: event.eventName,
        startedAt: (0, _1.formatDate)(event.startedAt, 'HH:mm'),
        endedAt: (0, _1.formatDate)(event.endedAt, 'HH:mm'),
        contentsCreateRequests: event.contentList.map(function (content) { return ({
            title: content.title,
            desc: content.content,
            startedAt: (0, _1.formatDate)(content.startedAt, 'HH:mm'),
        }); }),
    }); });
    var isScheduleAll = responseScheduleType === 'ALL';
    var scheduleType = isScheduleAll ? exports.ScheduleType.ALL : exports.ScheduleType.PLATFORM;
    var schedulePlatformType = isScheduleAll ? undefined : responseScheduleType;
    if (roadAddress) {
        return {
            name: name,
            generationNumber: generationNumber,
            scheduleType: scheduleType,
            schedulePlatformType: schedulePlatformType,
            date: date,
            sessions: sessions,
            locationType: exports.LocationType.OFFLINE,
            locationInfo: {
                roadAddress: roadAddress,
                latitude: String(latitude),
                longitude: String(longitude),
                detailAddress: detailAddress !== null && detailAddress !== void 0 ? detailAddress : '',
            },
            notice: notice,
        };
    }
    return {
        name: name,
        generationNumber: generationNumber,
        scheduleType: scheduleType,
        schedulePlatformType: schedulePlatformType,
        date: date,
        sessions: sessions,
        locationType: exports.LocationType.ONLINE,
        notice: notice,
    };
};
exports.parseScheduleResponseToFormValues = parseScheduleResponseToFormValues;
var parseFormValuesToScheduleRequest = function (formValues) {
    var _a, _b;
    var generationNumber = formValues.generationNumber, formScheduleType = formValues.scheduleType, schedulePlatformType = formValues.schedulePlatformType, date = formValues.date, sessions = formValues.sessions, name = formValues.name, locationType = formValues.locationType, locationInfo = formValues.locationInfo, notice = formValues.notice;
    var formattedDate = date.format('YYYY-MM-DD');
    var eventsCreateRequests = sessions.map(function (session) { return (__assign(__assign({}, session), { contentsCreateRequests: session.contentsCreateRequests.map(function (content) { return (__assign(__assign({}, content), { startedAt: (0, _1.toUtcFormat)("".concat(formattedDate, " ").concat(content.startedAt)) })); }), startedAt: (0, _1.toUtcFormat)("".concat(formattedDate, " ").concat(session.startedAt)), endedAt: (0, _1.toUtcFormat)("".concat(formattedDate, " ").concat(session.endedAt)) })); });
    var startedAt = (0, _1.toUtcFormat)("".concat(formattedDate, " ").concat((_a = sessions[0]) === null || _a === void 0 ? void 0 : _a.startedAt));
    var endedAt = (0, _1.toUtcFormat)("".concat(formattedDate, " ").concat((_b = sessions[sessions.length - 1]) === null || _b === void 0 ? void 0 : _b.endedAt));
    var scheduleRequest = {
        scheduleType: formScheduleType === exports.ScheduleType.ALL ? exports.ScheduleType.ALL : schedulePlatformType,
        generationNumber: generationNumber,
        name: name,
        startedAt: startedAt,
        endedAt: endedAt,
        eventsCreateRequests: eventsCreateRequests,
        notice: notice,
    };
    if (locationType === exports.LocationType.OFFLINE && locationInfo) {
        scheduleRequest.roadAddress = locationInfo.roadAddress;
        scheduleRequest.latitude = Number(locationInfo.latitude);
        scheduleRequest.longitude = Number(locationInfo.longitude);
        scheduleRequest.detailAddress = locationInfo.detailAddress;
    }
    return scheduleRequest;
};
exports.parseFormValuesToScheduleRequest = parseFormValuesToScheduleRequest;
